/*
 * Hash function takes user email's local-part and encodes to base64.
 */
export const getAuthHash = ({ email }: { email: string | null | undefined }): string =>
    btoa((email || '').split('@')[0]);
